import React, { ReactText } from 'react';
import styled from 'styled-components';
import { IconBase, IconBaseProps } from './IconBase';

export interface ChevronProps extends IconBaseProps {
  direction?: 'left' | 'right' | 'up' | 'down';
  stroke?: '2' | '2.5' | '3' | '4';
}

const calculateTransform = (direction?: ReactText) => {
  switch (direction) {
    case 'left':
      return 'rotate(90deg)';
    case 'right':
      return 'rotate(-90deg)';
    case 'up':
      return 'scaleY(-1)';
    case 'down':
      return 'scaleY(1)';
    default:
      return null;
  }
};

const StyledChevron = styled(IconBase)`
  flex-shrink: 0;
  transition: transform 0.15s ease-in-out;
  ${(props) => `transform: ${calculateTransform(props.direction)};`}
  polyline {
    fill: none;
    stroke: ${(props) => (props.color ? props.theme.palette[props.color].main : 'currentColor')};
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: ${(props) => (props.stroke ? props.stroke : '2')};
  }
`;

export const Chevron: React.SFC<ChevronProps> = (props) => (
  <StyledChevron {...props} viewBox="0 0 20 20">
    <polyline points="2 6 10 14 18 6" />
  </StyledChevron>
);
